var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFF1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.472 15.378a3.813 3.813 0 013.808 3.809c0 2.415-3.395 5.837-3.539 5.982a.38.38 0 01-.539 0c-.144-.145-3.539-3.567-3.539-5.982a3.813 3.813 0 013.809-3.809zM17.76 7.213a1.142 1.142 0 011.329 0l4.95 3.536c.3.215.478.56.478.93v2.176a.762.762 0 11-1.523 0V12.07a.38.38 0 00-.156-.308l-3.351-2.391a.19.19 0 00-.301.152v4.33a.762.762 0 01-1.524 0l.007-4.332a.19.19 0 00-.3-.153l-3.352 2.391a.38.38 0 00-.16.31v9.753a.191.191 0 00.302.152l2.05-1.468a.762.762 0 01.884 1.24l-3.332 2.38c-.405.29-.95.284-1.349-.015l-4.956-3.717A1.149 1.149 0 017 19.48V8.142a1.142 1.142 0 011.849-.898l4.037 3.117a.38.38 0 00.457.009zm-8.933 1.94a.19.19 0 00-.305.152V19.1c0 .12.057.232.153.304l3.351 2.514a.19.19 0 00.305-.152v-9.719a.38.38 0 00-.153-.304zm12.644 8.7a1.333 1.333 0 100 2.666 1.333 1.333 0 000-2.665z",
    fill: "#B5393F",
    fillRule: "nonzero"
  }))));
}
export default SvgGps;